export const getCurrentLanguage = () => {
  const locale = localStorage.getItem('locale')
  if (locale) {
    return locale
  }
  return navigator.languages !== undefined ? navigator.languages[0] : navigator.language
}
